<!-- Overlay -->
@if (isOpen()) {
  <div class="fixed inset-0 z-40 bg-black/50 transition-opacity" (click)="close()"></div>
}

<!-- Drawer -->
<div
  class="fixed inset-y-0 right-0 z-50 w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ease-out flex flex-col"
  [class.translate-x-0]="isOpen()"
  [class.translate-x-full]="!isOpen()">

  <!-- Header -->
  <div class="bg-linear-to-r from-blue-600 to-blue-700 text-white px-6 py-4 flex items-center justify-between">
    <div class="flex items-center gap-3">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
      </svg>
      <div>
        <h2 class="text-lg font-bold">Carrito de Pedido</h2>
        <p class="text-xs text-blue-100">{{ totalItems() }} items</p>
      </div>
    </div>
    <button (click)="close()" class="p-2 hover:bg-white/10 rounded-lg transition-colors">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- Content -->
  <div class="flex-1 overflow-y-auto">
    @if (isEmpty()) {
      <!-- Empty State -->
      <div class="flex flex-col items-center justify-center h-full text-center p-8">
        <div class="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-4">
          <svg class="w-10 h-10 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </div>
        <h3 class="text-lg font-bold text-slate-700 mb-2">Carrito vacío</h3>
        <p class="text-sm text-slate-500 mb-6">
          Agrega materiales o equipos desde el inventario para crear un pedido
        </p>
        <button (click)="close()" class="px-4 py-2 bg-blue-600 text-white text-sm font-bold rounded-lg hover:bg-blue-700 transition-colors">
          Explorar Inventario
        </button>
      </div>
    } @else {
      <div class="p-4 space-y-4">
        <!-- Materiales -->
        @if (materialesItems().length > 0) {
          <div>
            <h3 class="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3 flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
              </svg>
              Materiales ({{ totalMateriales() }})
            </h3>
            <div class="space-y-2">
              @for (item of materialesItems(); track item.recurso_id) {
                <div class="bg-white border border-slate-200 rounded-lg p-3 flex items-center gap-3 group hover:border-blue-300 transition-colors">
                  <!-- Imagen placeholder -->
                  <div class="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center shrink-0">
                    <svg class="w-6 h-6 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                    </svg>
                  </div>

                  <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-1.5 flex-wrap">
                      <h4 class="text-sm font-semibold text-slate-800 truncate">{{ item.nombre }}</h4>
                      @if (permisos.esAdmin && item.ubicacion_sector === 'PLANTA') {
                        <span class="px-1.5 py-0.5 bg-emerald-100 text-emerald-700 text-[9px] font-bold rounded uppercase shrink-0">Planta</span>
                      } @else if (permisos.esAdmin && item.ubicacion_sector === 'DEPOSITO_CENTRAL') {
                        <span class="px-1.5 py-0.5 bg-blue-100 text-blue-700 text-[9px] font-bold rounded uppercase shrink-0">Depósito</span>
                      }
                    </div>
                    @if (item.tipo_presentacion) {
                      <p class="text-xs text-slate-500">{{ item.tipo_presentacion }}</p>
                    }
                    @if (item.stock_actual !== null) {
                      <p class="text-[10px] text-slate-400">Stock: {{ item.stock_actual }}</p>
                    }
                  </div>

                  <!-- Cantidad -->
                  <div class="flex items-center gap-1">
                    <button (click)="updateCantidad(item, -1)"
                      class="w-7 h-7 flex items-center justify-center bg-slate-100 rounded text-slate-600 hover:bg-slate-200 transition-colors">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M20 12H4"/>
                      </svg>
                    </button>
                    <span class="w-8 text-center text-sm font-bold text-slate-700">{{ item.cantidad }}</span>
                    <button (click)="updateCantidad(item, 1)"
                      class="w-7 h-7 flex items-center justify-center bg-slate-100 rounded text-slate-600 hover:bg-slate-200 transition-colors"
                      [disabled]="item.stock_actual !== null && item.cantidad >= item.stock_actual"
                      [class.opacity-50]="item.stock_actual !== null && item.cantidad >= item.stock_actual"
                      [class.cursor-not-allowed]="item.stock_actual !== null && item.cantidad >= item.stock_actual">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M12 4v16m8-8H4"/>
                      </svg>
                    </button>
                  </div>

                  <!-- Eliminar -->
                  <button (click)="removeItem(item)"
                    class="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors opacity-0 group-hover:opacity-100">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
          </div>
        }

        <!-- Equipos -->
        @if (equiposItems().length > 0) {
          <div>
            <h3 class="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3 flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              Equipos ({{ totalEquipos() }})
            </h3>
            <div class="space-y-2">
              @for (item of equiposItems(); track item.recurso_id) {
                <div class="bg-white border border-slate-200 rounded-lg p-3 flex items-center gap-3 group hover:border-amber-300 transition-colors">
                  <!-- Imagen placeholder -->
                  <div class="w-12 h-12 bg-amber-50 rounded-lg flex items-center justify-center shrink-0">
                    <svg class="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    </svg>
                  </div>

                  <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-1.5 flex-wrap">
                      <h4 class="text-sm font-semibold text-slate-800 truncate">{{ item.nombre }}</h4>
                      @if (permisos.esAdmin && item.ubicacion_sector === 'PLANTA') {
                        <span class="px-1.5 py-0.5 bg-emerald-100 text-emerald-700 text-[9px] font-bold rounded uppercase shrink-0">Planta</span>
                      } @else if (permisos.esAdmin && item.ubicacion_sector === 'DEPOSITO_CENTRAL') {
                        <span class="px-1.5 py-0.5 bg-blue-100 text-blue-700 text-[9px] font-bold rounded uppercase shrink-0">Depósito</span>
                      }
                    </div>
                    @if (item.marca || item.modelo) {
                      <p class="text-xs text-slate-500">{{ item.marca }} {{ item.modelo }}</p>
                    }
                    @if (item.codigo) {
                      <p class="text-[10px] text-slate-400 font-mono">{{ item.codigo }}</p>
                    }
                  </div>

                  <!-- Badge equipo único -->
                  <span class="px-2 py-0.5 bg-amber-100 text-amber-700 text-[10px] font-bold rounded-full">
                    UNIDAD
                  </span>

                  <!-- Eliminar -->
                  <button (click)="removeItem(item)"
                    class="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors opacity-0 group-hover:opacity-100">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Footer -->
  @if (!isEmpty()) {
    <div class="border-t border-slate-200 bg-slate-50 p-4 space-y-3">

      <!-- Advertencia mezcla de sectores (solo admin) -->
      @if (permisos.esAdmin && hasMixedSectors()) {
        <div class="bg-amber-50 border border-amber-300 rounded-lg p-3 flex items-start gap-2 text-sm text-amber-800">
          <svg class="w-4 h-4 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
          </svg>
          <span>El pedido mezcla ítems de <strong>Planta</strong> y <strong>Depósito Central</strong>. Verificá que sea intencional.</span>
        </div>
      }

      <!-- Acciones -->
      <div class="flex gap-2">
        <button (click)="clearCart()"
          class="flex-1 px-4 py-2.5 border border-slate-300 text-slate-600 text-sm font-bold rounded-lg hover:bg-slate-100 transition-colors">
          Vaciar
        </button>
        <button (click)="procederAlPedido()"
          class="flex-2 px-4 py-2.5 bg-blue-600 text-white text-sm font-bold rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2">
          <span>Crear Pedido</span>
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/>
          </svg>
        </button>
      </div>
    </div>
  }
</div>
